import React from 'react';
import { Link } from 'react-router-dom';
import { Linkedin, Instagram, Twitter, MessageCircle, ArrowUpRight } from 'lucide-react';
import { NAV_LINKS } from '../data/mock';
import { useConnect } from '../context/ConnectContext';
import logo from '../assets/farmway-logo.png';

const socials = [
  { icon: Linkedin, label: 'LinkedIn' },
  { icon: Instagram, label: 'Instagram' },
  { icon: Twitter, label: 'X' },
  { icon: MessageCircle, label: 'Community' },
];

export default function Footer() {
  const { openConnect } = useConnect();
  return (
    <footer className="relative overflow-hidden border-t border-white/10 bg-farmway-green-dark">
      <div className="container-fw py-16">
        <div className="grid gap-12 md:grid-cols-2 lg:grid-cols-4">
          <div className="lg:col-span-2">
            <Link to="/" className="flex items-center gap-3">
              <img src={logo} alt="Farmway" className="h-11 w-11 rounded-xl object-cover ring-1 ring-farmway-leaf/30" />
              <span className="font-display text-xl font-extrabold tracking-[0.2em] text-farmway-cream">FARMWAY</span>
            </Link>
            <p className="mt-6 max-w-sm text-sm leading-relaxed text-farmway-cream/70">
              Democratizing access to future-proof farmland and agribusiness. Grounded, regenerative,
              and quietly confident. Growing tomorrow, today.
            </p>
            <div className="mt-7 flex items-center gap-3">
              {socials.map((s) => (
                <button
                  key={s.label}
                  aria-label={s.label}
                  className="grid h-10 w-10 place-items-center rounded-full border border-white/15 text-farmway-cream/70 transition-all duration-300 hover:border-farmway-gold hover:text-farmway-gold"
                >
                  <s.icon className="h-4 w-4" />
                </button>
              ))}
            </div>
          </div>

          <div>
            <h4 className="font-display text-xs font-semibold uppercase tracking-[0.24em] text-farmway-gold">Explore</h4>
            <ul className="mt-5 space-y-3">
              {NAV_LINKS.map((l) => (
                <li key={l.path}>
                  <Link to={l.path} className="text-sm text-farmway-cream/70 transition-colors hover:text-farmway-cream">
                    {l.label}
                  </Link>
                </li>
              ))}
              <li>
                <Link to="/investor-overview" className="text-sm text-farmway-cream/70 transition-colors hover:text-farmway-cream">
                  Investor Overview
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-display text-xs font-semibold uppercase tracking-[0.24em] text-farmway-gold">Get in touch</h4>
            <p className="mt-5 text-sm text-farmway-cream/70">
              Interested in farmland investing with Farmway?
            </p>
            <button onClick={openConnect} className="btn-gold mt-5">
              Connect <ArrowUpRight className="h-4 w-4" />
            </button>
          </div>
        </div>

        <div className="mt-14 flex flex-col items-center justify-between gap-4 border-t border-white/10 pt-8 sm:flex-row">
          <p className="font-display text-sm uppercase tracking-[0.3em] text-farmway-cream/50">
            Farm <span className="text-farmway-gold">·</span> Food <span className="text-farmway-gold">·</span> Future
          </p>
          <p className="text-xs text-farmway-cream/40">© Farmway Technologies Inc. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}
